export default "__VITE_ASSET__6371b9e2__"